import { Feature, isFeatureAvailableOnPlan } from "../featureAvailability";
import { Plan } from "./types";
import { getTitleForPlan } from "./utilities";

export const TRIAL_DURATION_DAYS = 14;
export const TRIAL_DURATION_SECONDS = TRIAL_DURATION_DAYS * 24 * 60 * 60;
export const trialDurationLabel = `${TRIAL_DURATION_DAYS} days`;
export const trialDurationHyphenated = `${TRIAL_DURATION_DAYS}-day`;

export function getTrialIncludedPlanNames(): string[] {
    const trialFeatures = Object.values(Feature).filter(
        (f) =>
            isFeatureAvailableOnPlan(f, Plan.UbpPremiumTrial) &&
            !isFeatureAvailableOnPlan(f, Plan.Public)
    );

    const paidPlans = [Plan.UbpCore, Plan.Enterprise];
    return paidPlans
        .filter((plan) => trialFeatures.some((f) => isFeatureAvailableOnPlan(f, plan)))
        .map((plan) => getTitleForPlan(plan));
}
